import React, { useEffect, useState } from "react";
import { GetNameChoose } from "../../funcUtils";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import swal from "sweetalert";

const History = ({ isOpen, closePopup }) => {
    const [historyGame, setHistoryGame] = useState(null);
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);

    useEffect(() => {
        if (isOpen) {
            axios
                .get(`${process.env.REACT_APP_API_URL}/history/historyus`, {})
                .then((res) => {
                    // 🔥 BỘ LỌC THÔNG MINH: CHỈ LẤY XỔ SỐ, LOẠI BỎ TÀI XỈU / XÓC ĐĨA 🔥
                    const filteredData = res.data.data.filter(item => {
                        const sanhStr = String(item?.sanh || "").toLowerCase();
                        const typeStr = String(item?.type || "").toLowerCase();
                        const gameStr = String(item?.game || "").toLowerCase();
                        
                        // Định nghĩa các từ khóa của Casino để loại bỏ
                        const isCasino = 
                            sanhStr.includes("tx") || sanhStr.includes("xd") || 
                            sanhStr.includes("tài xỉu") || sanhStr.includes("xóc đĩa") ||
                            sanhStr.includes("catdog") || sanhStr.includes("bầu cua") ||
                            typeStr.includes("tx") || typeStr.includes("xd") || typeStr.includes("catdog") ||
                            gameStr.includes("tx") || gameStr.includes("xd") || gameStr.includes("tài xỉu") || gameStr.includes("xóc đĩa");
                            
                        // Nếu KHÔNG phải là Casino -> Nó là Xổ Số -> Giữ lại (return true)
                        return !isCasino; 
                    });

                    // Cập nhật state bằng dữ liệu đã lọc sạch Casino
                    setHistoryGame(filteredData);
                })
                .catch((err) => {});
        }
    }, [isOpen]);

    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    const XSMN = [
        "Bạc Liêu",
        "Vũng Tàu",
        "Tiền Giang",
        "Kiên Giang",
        "Đà Lạt",
        "Bình Phước",
        "Bình Dương",
        "An Giang",
        "Bình Thuận",
        "Cà Mau",
        "Cần Thơ",
        "Hậu Giang",
        "Đồng Tháp",
        "Tây Ninh",
        "Vĩnh Long",
        "Trà Vinh",
        "Sóc Trăng",
        "Long An",
        "TP. HCM",
        "Đồng Nai",
        "Bến Tre"
    ];

    const XSMT = [
        "Đà Nẵng",
        "Thừa T. Huế",
        "Quảng Trị",
        "Phú Yên",
        "Quảng Bình",
        "Quảng Nam",
        "Quảng Ngãi",
        "Ninh Thuận",
        "Kon Tum",
        "Khánh Hòa",
        "Gia Lai",
        "Bình Định",
        "Đắk Lắk",
        "Đắk Nông"
    ];

    const checkCancel = (item) => {
        const datexs = new Date(item.id_bet);
        const ngayxs = datexs.getDate();
        const thangxs = datexs.getMonth() + 1;
        const namxs = datexs.getFullYear();
        const currentDate = new Date();
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        const formattedDate = `${day < 10 ? "0" + day : day}/${month < 10 ? "0" + month : month}/${year}`;
        const minute = currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes();

        if (item.sanh === "XSMB" && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1800) {
            return false;
        } else if (XSMT.includes(item?.sanh) && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1700) {
            return false;
        } else if (XSMN.includes(item?.sanh) && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1600) {
            return false;
        } else {
            return true;
        }
    };

    return (
        <>
            <div className={isOpen ? "history-sidebar active" : "history-sidebar"}>
                <div className={isOpen ? "history-backdrop active" : "history-backdrop"} onClick={closePopup}>
                    <div className="history-main">
                        <div className="history-header">Lịch Sử Tham Gia</div>
                        <div className="history-content">
                            {historyGame != null ? (
                                <div className="content-history">
                                    {historyGame?.map((item, key) => (
                                        <React.Fragment key={key}>
                                            {item.type ? (
                                                <div
                                                    className="item_inner"
                                                    onClick={(e) => {
                                                        console.log(item);
                                                        setLs(item);
                                                        setShow(true);
                                                        e.stopPropagation();
                                                    }}>
                                                    <div className="item_history">
                                                        <div className="title_item_history">
                                                            <span className="sanh"> {item.sanh}</span>
                                                            <span
                                                                className={`type_state ${
                                                                    item.status_bet === "Pending"
                                                                        ? "pending"
                                                                        : item.status_bet === "Win"
                                                                        ? "win"
                                                                        : item.status_bet === "Lose"
                                                                        ? "lose"
                                                                        : "cancelled"
                                                                }`}>
                                                                {item.status_bet === "Pending"
                                                                    ? "Chờ xổ"
                                                                    : item.status_bet === "Win"
                                                                    ? "Thắng"
                                                                    : item.status_bet === "Lose"
                                                                    ? "Thua"
                                                                    : "Đã hủy"}
                                                            </span>
                                                            {item?.status_bet === "Pending" && (
                                                                <>
                                                                    {(item?.sanh == "XSMB" || XSMN.includes(item?.sanh) || XSMT.includes(item?.sanh)) && (
                                                                        <>
                                                                            {checkCancel(item) && (
                                                                                <span
                                                                                    className="cancel-bet type_state"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        e.target.style.display = "none";
                                                                                        const currentDate = new Date();
                                                                                        const day = currentDate.getDate();
                                                                                        const month = currentDate.getMonth() + 1;
                                                                                        const year = currentDate.getFullYear();
                                                                                        const formattedDate = `${day < 10 ? "0" + day : day}/${
                                                                                            month < 10 ? "0" + month : month
                                                                                        }/${year}`;
                                                                                        const minute =
                                                                                            currentDate.getMinutes() < 10
                                                                                                ? "0" + currentDate.getMinutes()
                                                                                                : currentDate.getMinutes();
                                                                                        if (
                                                                                            item.sanh === "XSMB" &&
                                                                                            Number(currentDate.getHours() + "" + minute) >= 1800 &&
                                                                                            Number(currentDate.getHours() + "" + minute) < 1915
                                                                                        ) {
                                                                                            swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
                                                                                            e.stopPropagation();
                                                                                            return false;
                                                                                        } else if (
                                                                                            XSMT.includes(item?.sanh) &&
                                                                                            item?.id_bet == formattedDate &&
                                                                                            Number(currentDate.getHours() + "" + minute) >= 1700 &&
                                                                                            Number(currentDate.getHours() + "" + minute) < 1815
                                                                                        ) {
                                                                                            swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
                                                                                            e.stopPropagation();
                                                                                            return false;
                                                                                        } else if (
                                                                                            XSMN.includes(item?.sanh) &&
                                                                                            item?.id_bet == formattedDate &&
                                                                                            Number(currentDate.getHours() + "" + minute) >= 1600 &&
                                                                                            Number(currentDate.getHours() + "" + minute) < 1715
                                                                                        ) {
                                                                                            swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
                                                                                            e.stopPropagation();
                                                                                            return false;
                                                                                        }
                                                                                        axios
                                                                                            .patch(`${process.env.REACT_APP_API_URL}/history/cancel`, {
                                                                                                id: item?._id,
                                                                                                userId: item?.user?._id,
                                                                                                money: item?.money
                                                                                            })
                                                                                            .then((res) => {
                                                                                                setShow(false);
                                                                                                swal("Hủy cược thành công", "", "success").then((value) => {
                                                                                                    axios
                                                                                                        .get(`${process.env.REACT_APP_API_URL}/history/historyus`, {})
                                                                                                        .then((res) => {
                                                                                                            // Chạy lại bộ lọc sau khi hủy
                                                                                                            const filteredData = res.data.data.filter(i => {
                                                                                                                const s = String(i?.sanh || "").toLowerCase();
                                                                                                                const t = String(i?.type || "").toLowerCase();
                                                                                                                const g = String(i?.game || "").toLowerCase();
                                                                                                                const isCas = s.includes("tx") || s.includes("xd") || s.includes("tài xỉu") || s.includes("xóc đĩa") || s.includes("catdog") || s.includes("bầu cua") || t.includes("tx") || t.includes("xd") || t.includes("catdog") || g.includes("tx") || g.includes("xd") || g.includes("tài xỉu") || g.includes("xóc đĩa");
                                                                                                                return !isCas; 
                                                                                                            });
                                                                                                            setHistoryGame(filteredData);
                                                                                                        })
                                                                                                        .catch((err) => {});
                                                                                                });
                                                                                            })
                                                                                            .catch((err) => {
                                                                                                setShow(false);
                                                                                                swal("Thông báo", "Đã xảy ra lỗi, vui lòng thử lại!", "error");
                                                                                                e.target.style.display = "inline-block";
                                                                                            });
                                                                                    }}
                                                                                >
                                                                                    &times; Hủy cược
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className="id_history_sanh">Phiên cược: {item?.id_bet?.id_bet ? item?.id_bet?.id_bet : item?.id_bet}</div>
                                                        <div className="id_history_sanh">{GetNameChoose(item.state, item.type)}</div>
                                                    </div>
                                                    <div className="money_history">
                                                        <span className="money">{Number(item.money).toLocaleString("vi-VN")}₫</span>
                                                        <div className="time_choose">{formatDate(new Date(item.createdAt))}</div>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </React.Fragment>
                                    ))}
                                </div>
                            ) : (
                                <div></div>
                            )}
                        </div>
                        <div onClick={closePopup} className="history-close">
                            <CloseIcon sx={{ fontSize: "0.55rem" }} />
                        </div>
                    </div>
                </div>
            </div>
           {isShow === true && ls && ls.status_bet !== "Pending" ? (
    <div className="modal" style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999999
    }}>
        <div className="modaloverlay" 
            onClick={() => setShow(false)}
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                cursor: "pointer"
            }}
        ></div>

        <div className="modalbody" style={{
            position: "relative",
            zIndex: 10,
            backgroundColor: "#ffffff",
            color: "#000000",
            borderRadius: "8px",
            width: "90%",
            maxWidth: "350px",
            padding: "15px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.5)"
        }}>
            <div>
                <div className="modalinner">
                    <div className="modalheader" style={{ paddingBottom: "15px", textAlign: "center", fontSize: "18px", fontWeight: "bold", borderBottom: "1px solid #333", marginBottom: "15px" }}>
                        Chi tiết cược
                    </div>

                    {ls.id_bet ? (
                        <>
                            <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                <div>Trò chơi</div>
                                <div>{ls.sanh}</div>
                            </div>
                            <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                <div>Phiên</div>
                                <div>{ls.id_bet.id_bet ? ls.id_bet.id_bet : ls.id_bet}</div>
                            </div>
                            <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                <div>Thời gian</div>
                                <div>{formatDate(new Date(ls.createdAt))}</div>
                            </div>
                            <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                <div>Đặt cược</div>
                                <div style={{ color: "#d32f2f", fontWeight: "bold" }}>
                                    {GetNameChoose(ls.state, ls.type, ls.sanh)}
                                </div>
                            </div>
                            <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                <div>Tổng Cược</div>
                                <div>{Number(ls.money).toLocaleString("vi-VN")} ₫</div>
                            </div>
                            <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
                                <div>Tổng thắng</div>
                                <div style={{ color: "#28a745", fontWeight: "bold" }}>
                                    {Number(ls.moneythang).toLocaleString("vi-VN")} ₫
                                </div>
                            </div>
                        </>
                    ) : null}
                    
                    <div>
                        <div className="modalformcontrols">
                            <button
                                onClick={() => setShow(false)}
                                className="popup-close"
                                style={{
                                    background: "#dc3545", // Đỏ đẹp mắt hơn
                                    color: "#fff",
                                    border: "none",
                                    boxShadow: "none",
                                    textShadow: "none",
                                    width: "100%",
                                    marginTop: "5px",
                                    padding: "12px",
                                    borderRadius: "5px",
                                    fontWeight: "bold",
                                    cursor: "pointer"
                                }}>
                                ĐÓNG
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
) : null}
        </>
    );
};

export default History;